export default [
  {
    name: 'sport',
    type: 'autocomplete',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: false,
    icon: 'layers',
    origin: 'sports',
  },
  {
    name: 'date',
    type: 'date',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    columns: 2,
  },
  {
    name: 'hour',
    type: 'hour',
    value: '',
    validation: { required: true, regex: /^([0-2]?[0-9]:[0-5][0-9])$/ },
    tableDisplay: true,
    allowEdit: true,
    columns: 2,
  },
  {
    name: 'category',
    type: 'autocompleteClub',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    origin: 'categories',
  },
  {
    name: 'localTeam',
    type: 'autocompleteClub',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    origin: 'teams',
  },
  {
    name: 'visitorTeam',
    type: 'autocompleteClub',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    origin: 'teams',
  },
  {
    name: 'location',
    type: 'autocompleteClub',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    origin: 'locations',
  },
  {
    name: 'order',
    type: 'number',
    value: '',
    validation: { required: true },
    tableDisplay: true,
    allowEdit: true,
  },
  {
    name: 'day',
    type: 'number',
    value: '',
    validation: { required: false },
    tableDisplay: true,
    allowEdit: true,
  },
]
